<template>
  <div class="container">
    <section id="editContent">
      <h1 class="contentTitle">캐스트잇 관리자 설정</h1>
      <Category />
    </section>
  </div>
</template>

<script>
import Category from '@/components/SuperAdmin/Category.vue'

export default {
  name: 'SuperAdmin',
  components: {
    Category
  }
}
</script>
